import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../data/mockData';

const Footer = () => {
  const { language } = useLanguage();
  const t = translations[language];

  const footerLinks = [
    { path: '/', label: t.nav.home },
    { path: '/services', label: t.nav.services },
    { path: '/aircraft', label: t.nav.aircraft },
    { path: '/projects', label: t.nav.projects },
    { path: '/about', label: t.nav.about },
    { path: '/faq', label: t.nav.faq },
    { path: '/contact', label: t.nav.contact }
  ];

  return (
    <footer className="bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <img
              src="https://customer-assets.emergentagent.com/job_d8d5fc8a-374d-4382-9a90-eb0bda24b30a/artifacts/ky6pa3wr_White%20Background.png"
              alt="Prestaco Logo"
              className="h-12 w-auto"
            />
            <p className="text-sm text-gray-300 leading-relaxed">
              {t.footer.description}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">{t.footer.quickLinks}</h3>
            <ul className="space-y-2">
              {footerLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-gray-300 hover:text-white transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4">{t.footer.services}</h3>
            <ul className="space-y-2 text-sm text-gray-300">
              <li>{language === 'fr' ? 'Équipements Professionnels' : 'Professional Equipment'}</li>
              <li>{language === 'fr' ? 'Informatique' : 'IT Solutions'}</li>
              <li>{language === 'fr' ? 'Véhicules' : 'Vehicles'}</li>
              <li>{language === 'fr' ? 'Capacités Aériennes' : 'Air Capabilities'}</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">{t.footer.contact}</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3 text-sm text-gray-300">
                <MapPin className="h-5 w-5 mt-0.5 flex-shrink-0 text-blue-400" />
                <span>{t.contact.info.address}</span>
              </li>
              <li className="flex items-center space-x-3 text-sm text-gray-300">
                <Phone className="h-5 w-5 flex-shrink-0 text-blue-400" />
                <span>{t.contact.info.phone}</span>
              </li>
              <li className="flex items-center space-x-3 text-sm text-gray-300">
                <Mail className="h-5 w-5 flex-shrink-0 text-blue-400" />
                <span>{t.contact.info.email}</span>
              </li>
              <li className="flex items-center space-x-3 text-sm text-gray-300">
                <Clock className="h-5 w-5 flex-shrink-0 text-blue-400" />
                <span>{t.contact.info.hours}</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 mt-8 pt-8 text-center">
          <p className="text-sm text-gray-400">
            © {new Date().getFullYear()} PRESTACO. {t.footer.rights}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;